import { render, staticRenderFns } from "./ProductStatusInput.vue?vue&type=template&id=04b25d71&scoped=true&"
import script from "./ProductStatusInput.vue?vue&type=script&lang=js&"
export * from "./ProductStatusInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b25d71",
  null
  
)

export default component.exports